import {ScriptsHttp} from "@/http/ScriptsHttp";

export default {
    async setScripts({commit}) {
        const scripts = await ScriptsHttp.getScripts().then(result => result.data);
        commit('setScripts', scripts);
    },
    setActiveScript({commit}, activeScript) {
        commit('setActiveScript', activeScript);
    },
    setManageScriptDialog({commit}, status) {
        commit('setManageScriptDialog', status);
    },
    setManageDeleteScriptDialog({commit}, status) {
        commit('setManageDeleteScriptDialog', status);
    }
}
